import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "assets/images/logo.svg";
import footerLogo from "assets/images/footerLogo.svg";
import myPlan from "assets/images/sidebar/myPlan.svg";
import myPlan1 from "assets/images/sidebar/myPlan2.svg";
import overview2 from "assets/images/sidebar/overview2.svg";
import reviews from "assets/images/sidebar/reviews.svg";
import reviews2 from "assets/images/sidebar/reviews2.svg";
import meetingRooms from "assets/images/sidebar/meetingRooms.svg";
import meetingRooms2 from "assets/images/sidebar/meetingRooms2.svg";
import orders from "assets/images/sidebar/orders.svg";
import orders2 from "assets/images/sidebar/orders2.svg";
import overview from "assets/images/sidebar/overview.svg";
import workshops from "assets/images/sidebar/workshops.svg";
import workshops2 from "assets/images/sidebar/workshops2.svg";
import workspace from "assets/images/sidebar/workspace.svg";
import workspace2 from "assets/images/sidebar/workspace2.svg";
import branches from "assets/images/sidebar/branches.svg";
import branches2 from "assets/images/sidebar/branches2.svg";
import wsManagement from "assets/images/sidebar/wsManagement.svg";
import wsManagement2 from "assets/images/sidebar/wsManagement2.svg";
import setting from "assets/images/sidebar/setting.svg";
import setting2 from "assets/images/sidebar/setting2.svg";
import rewards from "assets/images/sidebar/rewards.svg";
import rewards2 from "assets/images/sidebar/rewards2.svg";
import coupons from "assets/images/sidebar/coupons.svg";
import coupons2 from "assets/images/sidebar/coupons2.svg";
import customers from "assets/images/sidebar/customers.svg";
import customers2 from "assets/images/sidebar/customers2.svg";
import users from "assets/images/sidebar/users.svg";
import users2 from "assets/images/sidebar/users2.svg";
import arrowRight from "assets/images/icons/arrowRight.svg";
import city from "assets/images/sidebar/city.svg";
import city2 from "assets/images/sidebar/city2.svg";
import websiteRequest from "assets/images/sidebar/websiteRequest.svg";
import websiteRequest2 from "assets/images/sidebar/websiteRequest2.svg";
import amenity from "assets/images/sidebar/amenity.svg";
import amenity2 from "assets/images/sidebar/amenity2.svg";
import apiLogs from "assets/images/sidebar/apiLogs.svg";
import apiLogs2 from "assets/images/sidebar/apiLogs2.svg";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  hasMenuPermission,
  hasPermission,
} from "components/constants/Permissions";
import { setIsPermissionChecked } from "store/reducers/authReducer";
import { ChevronDown, ChevronRight } from "lucide-react";
import { getNewWorkshopRequestCount } from "store/actions/workspaceSlice";

const Sidebar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isSubMenuOpen, setIsSubMenuOpen] = useState({
    workshops: false,
    rewards: false,
  });

  const { isGettingUserDetails, adminPermissions, accountType } = useSelector(
    (state) => state.auth
  );

  const { newWorkshopRequestCount = null } = useSelector(
    (state) => state.Workspace || {}
  );

  // Function to handle toggle for sub-menu
  const toggleSubMenu = (menu) => {
    setIsSubMenuOpen((prevState) => ({
      ...prevState,
      [menu]: !prevState[menu],
    }));
  };

  // Function to add 'active' class to the active link
  const isActive = (paths) =>
    paths.includes(location.pathname) ? "active" : "";

  // ACTIVE or OPEN SUB LINKS
  useEffect(() => {
    const path = location.pathname;
    // Automatically set submenu state based on the current path
    setIsSubMenuOpen({
      workshops: path.includes("/bookings/workshops"),
      rewards: path.includes("/rewards"), // Changed to detect any rewards path
    });
  }, [location.pathname]);

  useEffect(() => {
    dispatch(setIsPermissionChecked(true)); // Start permission checking
    dispatch(getNewWorkshopRequestCount());
    const currentPath = location.pathname;
    console.log(newWorkshopRequestCount);

    // Map paths to permission IDs
    const permissionMap = {
      "/dashboards/overview": "1_1",
      "/dashboards/reviews": "1_2",
      "/dashboards/reviews/review-history": "1_3",
      "/bookings/bookings": "2_1",
      "/bookings/workspace": "2_2",
      "/bookings/meeting-rooms": "2_3",
      "/bookings/workshops": "2_4",
      "/management/cities": "3_1",
      "/management/amenities": "3_2",
      "/management/branches": "3_3",
      "/users": "5_2",
    };

    const currentPermissionId = permissionMap[currentPath];

    const checkPermissions = async () => {
      if (
        !isGettingUserDetails && // Ensure user details are loaded
        currentPermissionId &&
        !hasPermission(accountType, adminPermissions, currentPermissionId)
      ) {
        // Find the first accessible route
        const findFirstAccessibleRoute = () => {
          for (const group of adminPermissions) {
            for (const child of group.children) {
              if (child.permissions.isView) {
                const route = Object.keys(permissionMap).find(
                  (key) => permissionMap[key] === child.id
                );
                return route;
              }
            }
          }
          dispatch();
          return "/"; // Default redirect if no accessible routes
        };

        const redirectTo = findFirstAccessibleRoute();
        if (redirectTo) navigate(redirectTo, { replace: true });
      }

      // Simulate permission check delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      dispatch(setIsPermissionChecked(false)); // Stop checking after permission verification
    };

    checkPermissions();
  }, [
    location.pathname,
    accountType,
    adminPermissions,
    navigate,
    isGettingUserDetails,
    dispatch,
  ]); // Ensure dependencies are correct

  return (
    <div className="sidebar_menu">
      <div className="sidebar_logo company_logo">
        <Link to={"/dashboards/overview"}>
          <img src={footerLogo} alt="Work Space Logo" width={145} height={29} />
        </Link>
      </div>
      <nav id="sidebar-menu">
        <ul>
          {hasMenuPermission(accountType, adminPermissions, 1) && (
            <li className="menu-title">{t("Dashboards")} </li>
          )}
          {hasPermission(accountType, adminPermissions, "1_1") && (
            <li>
              <Link
                to="/dashboards/overview"
                className={isActive(["/dashboards/overview"])}
              >
                <img
                  src={overview}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={overview2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                {t("Overview")}
              </Link>
            </li>
          )}
          {/* {hasPermission(accountType, adminPermissions, "1_1") && (
            <li>
              <Link
                to="/membership/my-plan"
                className={isActive(["/membership/my-plan"])}
              >
                <img
                  src={myPlan}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={myPlan1}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                {t("My Plan")}
              </Link>
            </li>
          )} */}
          {hasPermission(accountType, adminPermissions, "1_2") && (
            <li>
              <Link
                to="/dashboards/reviews"
                className={isActive(["/dashboards/reviews"])}
              >
                <img
                  src={reviews}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={reviews2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                {t("Reviews")}
              </Link>
            </li>
          )}
          {hasPermission(accountType, adminPermissions, "1_3") && (
            <li>
              <Link
                to="/dashboards/reviews/review-history"
                className={isActive(["/dashboards/reviews/review-history"])}
              >
                <img
                  src={reviews}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={reviews2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                {t("Reviews History")}
              </Link>
            </li>
          )}

          {/* BOOKINGS */}
          {hasMenuPermission(accountType, adminPermissions, 2) && (
            <li className="menu-title">{t("Bookings")}</li>
          )}

          {hasPermission(accountType, adminPermissions, "2_1") && (
            <li>
              <Link
                to="/bookings/bookings"
                className={isActive([
                  "/bookings/bookings",
                  "/bookings/bookings/booking-details",
                ])}
              >
                <img
                  src={orders}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={orders2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                {t("Bookings")}
              </Link>
            </li>
          )}

          {hasPermission(accountType, adminPermissions, "2_2") && (
            <li>
              <Link
                to="/bookings/workspace"
                className={isActive([
                  "/bookings/workspace",
                  "/bookings/workspace/add-new",
                  "/bookings/workspace/workspace-details",
                  "/bookings/workspace/edit-workspace",
                ])}
              >
                <img
                  src={workspace}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={workspace2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                {t("Workspace")}
              </Link>
            </li>
          )}

          {hasPermission(accountType, adminPermissions, "2_3") && (
            <li>
              <Link
                to="/bookings/meeting-rooms"
                className={isActive([
                  "/bookings/meeting-rooms",
                  "/bookings/meeting-rooms/meeting-room-details",
                  "/bookings/meeting-rooms/update-meeting-room",
                  "/bookings/meeting-rooms/add-new",
                ])}
              >
                <img
                  src={meetingRooms}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={meetingRooms2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                {t("Meeting Rooms")}
              </Link>
            </li>
          )}

          {hasPermission(accountType, adminPermissions, "2_4") && (
            <li
              className={`menu-item`}
              onClick={() => toggleSubMenu("workshops")}
            >
              <Link
                to="/bookings/workshops"
                className={`p_r ${isActive([
                  "/bookings/workshops",
                  "/bookings/workshops/workshop-details",
                  "/bookings/workshops/update-workshop",
                ])}`}
              >
                <ChevronRight
                  className={`arrow_right_icon ${
                    isSubMenuOpen.workshops ? "active" : ""
                  }`}
                />
                {/* <img
                  src={arrowRight}
                  className={`arrow_right_icon ${
                    isSubMenuOpen.workshops ? "active" : ""
                  }`}
                  alt="Icon"
                  width={16}
                  height={16}
                /> */}
                <img
                  src={workshops}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={workshops2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                {t("Workshops")}
                {newWorkshopRequestCount > 0 && (
                  <span className="notification-badge">
                    {newWorkshopRequestCount}
                  </span>
                )}
              </Link>
              <ul
                className={`sub-menu ${isSubMenuOpen.workshops ? "open" : ""}`}
              >
                <li>
                  <Link
                    to="/bookings/workshops/add-new"
                    className={isActive([
                      "/bookings/workshops/add-new" ||
                        "/bookings/workshops/update-workshop",
                    ])}
                  >
                    {t("Add New")}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/bookings/workshops/workshops-requests"
                    className={isActive([
                      "/bookings/workshops/workshops-requests",
                    ])}
                  >
                    {t("Requests")}
                    {newWorkshopRequestCount > 0 && (
                      <span className="notification-badge-2">
                        {newWorkshopRequestCount}
                      </span>
                    )}
                  </Link>
                </li>
              </ul>
            </li>
          )}

          {/* {hasPermission(accountType, adminPermissions, "2_5") && (
            <li>
              <Link
                to="/bookings/website-requests"
                className={isActive(["/bookings/website-requests"])}
              >
                <img
                  src={websiteRequest}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={websiteRequest2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                {t("Website Requests")}
              </Link>
            </li>
          )} */}

          {hasMenuPermission(accountType, adminPermissions, 3) && (
            <li className="menu-title">{t("Management")}</li>
          )}

          {/* {hasPermission(accountType, adminPermissions, "3_1") && (
            <li>
              <Link
                to="/management/cities"
                className={isActive(["/management/cities"])}
              >
                <img
                  src={city}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={city2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />

                {t("Cities")}
              </Link>
            </li>
          )} */}

          {hasPermission(accountType, adminPermissions, "3_2") && (
            <li>
              <Link
                to="/management/amenities"
                className={isActive(["/management/amenities"])}
              >
                <img
                  src={amenity}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={amenity2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />

                {t("Amenities")}
              </Link>
            </li>
          )}

          {hasPermission(accountType, adminPermissions, "3_3") && (
            <li>
              <Link
                to="/management/branches"
                className={isActive([
                  "/management/branches",
                  "/management/branches/add-branch",
                  "/management/branches/branch-details",
                  "/management/branches/update-branch",
                ])}
              >
                <img
                  src={branches}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={branches2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                {t("Branches")}
              </Link>
            </li>
          )}

          {/* {hasPermission(accountType, adminPermissions, "3_4") && (
            <li>
              <Link
                to="/management/ws-management"
                className={isActive([
                  "/management/ws-management",
                  "/management/ws-management/add-new-closure",
                  "/management/ws-management/update-closure",
                  "/management/ws-management/closure-details",
                ])}
              >
                <img
                  src={wsManagement}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={wsManagement2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                {t("WS Management")}
              </Link>
            </li>
          )} */}

          {/* {hasPermission(accountType, adminPermissions, "3_5") && (
            <li>
              <Link
                to="/management/settings"
                className={isActive([
                  "/management/settings",
                  "/management/settings/notifications",
                  "/management/settings/privacy-and-security",
                  "/management/settings/introduction-page",
                  "/management/settings/global-settings",
                ])}
              >
                <img
                  src={setting}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={setting2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />

                {t("Settings")}
              </Link>
            </li>
          )} */}

          {/* {hasPermission(accountType, adminPermissions, "3_6") && (
            <li>
              <Link
                to="/management/api-logs"
                className={isActive([
                  "/management/api-logs",
                  "/management/api-logs/details",
                ])}
              >
                <img
                  src={apiLogs}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={apiLogs2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />

                {t("API Logs")}
              </Link>
            </li>
          )} */}

          {/* Rewards Submenu */}
          {/* {hasMenuPermission(accountType, adminPermissions, 4) && (
            <li className="menu-item" onClick={() => toggleSubMenu("rewards")}>
              <Link
                to="/rewards/rewards"
                className={`p_r ${isActive([
                  "/rewards/rewards",
                  "/rewards/cashback",
                  "/rewards/coupon",
                  "/rewards/rewards-page",
                ])} `}
              >
                <ChevronRight
                  className={`arrow_right_icon ${
                    isSubMenuOpen.rewards ? "active" : ""
                  }`}
                />
                <img
                  src={rewards}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={rewards2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                {t("Rewards")}
              </Link>
              <ul className={`sub-menu ${isSubMenuOpen.rewards ? "open" : ""}`}>
                <li>
                  <Link
                    to="/rewards/cashback"
                    className={isActive(["/rewards/cashback"])}
                  >
                    {t("Cashback")}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/rewards/referral"
                    className={isActive(["/rewards/referral"])}
                  >
                    {t("Referral Code")}
                  </Link>
                </li>
              </ul>
            </li>
          )} */}

          {/* {hasPermission(accountType, adminPermissions, "4_2") && (
            <li>
              <Link
                to="/rewards/coupons"
                className={isActive([
                  "/rewards/coupons",
                  "/rewards/coupons/add-new-coupon",
                  "/rewards/coupons/update-coupon",
                ])}
              >
                <img
                  src={coupons}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={coupons2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />

                {t("Coupons")}
              </Link>
            </li>
          )} */}

          {/* CUSTOMERS & USERS */}
          {hasMenuPermission(accountType, adminPermissions, 5) && (
            <li className="menu-title">{t("Customers, Users")}</li>
          )}
          {hasPermission(accountType, adminPermissions, "5_1") && (
            <li>
              <Link
                className={isActive([
                  "/customers",
                  "/customers/customer-information",
                ])}
                to="/customers"
              >
                <img
                  src={customers}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={customers2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                {t("Customers")}
              </Link>
            </li>
          )}
          {/* {accountType === "superadmin" && (
            <li>
              <Link className={isActive(["/roles"])} to="/roles">
                <img
                  src={users}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={users2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                {t("Roles")}
              </Link>
            </li>
          )} */}

          {/* {hasPermission(accountType, adminPermissions, "5_2") && (
            <li>
              <Link
                className={isActive(["/users", "/users/user-details"])}
                to="/users"
              >
                <img
                  src={users}
                  className="main_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                <img
                  src={users2}
                  className="hover_icon"
                  alt="Icon"
                  width={20}
                  height={20}
                />
                {t("Users")}
              </Link>
            </li>
          )} */}
        </ul>
        <div className="footer_logo">
          <img src={footerLogo} alt="logo" width={145} height={29} />
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
